// SubcategoryWiseProduct.tsx

import React, { useEffect, useState } from 'react';
import Subcategories from '../Subcategories/Subcategories';
import ProductList from '../ProductList/ProductList';
import Section from '../Section/Section';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import Heading from '../Heading/Heading';
import { Product_list } from '../../Api';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/Store/Store';
import { useTranslation } from "react-i18next";
import { STORAGE_CONSTANTS } from '../../shared/Constants/Constants';
import lottieProductList from '../../assets/lotties/productList.json';
import { Player } from "@lottiefiles/react-lottie-player";

const SubcategoryWiseProduct: React.FC = (props) => {
  interface Category {
    id: string;
    product_name: string;
    product_image: string;
    price: string | null;
    weight: string | null;
    language_data: any
    product_vendor_store: any;
    store_name: string
  }

  const { t } = useTranslation();

  const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
  const [latitude, setLatitude] = React.useState<string | null>("");
  const [longitude, setLongitude] = React.useState<string | null>("");
  const [productData, setProductData] = React.useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const userLatitude = useSelector((state: RootState) => state.Location.selected_latitude)
  const userLongitude = useSelector((state: RootState) => state.Location.selected_longitude)
  const userPincode = useSelector((state: RootState) => state.Location.pincode);
  const [page, setPage] = useState<number>(1);
  const [limit] = useState<number>(12);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);

  useEffect(() => {
    setLatitude(localStorage.getItem(STORAGE_CONSTANTS.LATITUDE))
    setLongitude(localStorage.getItem(STORAGE_CONSTANTS.LONGITUDE))
  }, []);

  const handleSubcategorySelect = (subcateId: string) => {
    if (subcateId == selectedSubcategory) return;
    setLoading(true)
    setPage(1);
    setProductData([]);
    setHasMore(true);
    setSelectedSubcategory(subcateId);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await Product_list(
          selectedSubcategory,
          userLatitude,
          userLongitude,
          userPincode,
          limit,
          page
        );

        if (response && response.status === 200) {
          const productList = response.data.product_list;
          const next = response.data.next;
          if (productList && productList.length > 0) {
            setProductData((prevProducts) => [
              ...prevProducts,
              ...productList,
            ]);
            setHasMore(!!next);
          } else {
            console.log("No more products to load.");
          }
        } else {
          console.error("Error while fetching Products: Invalid response status.");
        }
      } catch (error) {
        if (error instanceof Error) {
          console.error("Error while fetching Products:", error.message);
        } else {
          console.error("Unexpected error while fetching Products:", error);
        }
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    };

    if (selectedSubcategory) {
      fetchProducts();
    }
  }, [selectedSubcategory, page, userLatitude, userLongitude, userPincode]);

  const products: Category[] = selectedSubcategory ? productData : []

  const handleLoadMore = () => {
    setLoadingMore(true);
    setPage(prevPage => prevPage + 1);
  };


  const containerStyle: React.CSSProperties = {
    height: "100%",
    minHeight: "100%",
    // flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: 0,
    marginLeft: "auto",
    marginRight: "auto"
  };

  const rowStyle: React.CSSProperties = {
    flex: 1,
    height: "100%",
    minHeight: "0",
    display: "flex",
    flexWrap: "nowrap",
    margin: 0,
  };

  const sidebarStyle: React.CSSProperties = {
    borderRightWidth: 1,
    borderRightStyle: "solid",
    borderRightColor: "var(--gray-light)",
    paddingRight: 0,
    height: "100vh",
    minHeight: "100vh",
    position: "sticky",
    top: 0,
    overflowY: "auto",
    background: "#fff",
    zIndex: 2,
    flex: "0 0 25%",
    maxWidth: "25%",
  };

  const productColStyle: React.CSSProperties = {
    height: "100vh",
    minHeight: "100vh",
    overflowY: "auto",
    flex: "1 1 75%",
    maxWidth: "75%",
    paddingBottom: 32,
    background: "#fafbfc",
  };

  return (
    <Section className="subcateoryWiseProduct">
      <Container style={containerStyle}>
        <Row style={{ marginTop: 30, marginBottom: 20 }}>
          <Col>
            <Heading text={t("homeScreen.titleSectionProducts")} alignment="left" />
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col sm={3} style={sidebarStyle}>
            <Subcategories onSubcategorySelect={handleSubcategorySelect} />
          </Col>
          <Col sm={9} style={productColStyle}>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center h-100">
                <Player
                  src={lottieProductList}
                  loop
                  autoplay
                  className="player"
                  style={{ height: '300px' }}
                />
              </div>
            ) : (
              <>
                <ProductList selectedSubcategory={selectedSubcategory} products={products} />
               
                {productData.length > 0 && hasMore && (
                  <Row className="d-flex align-items-center justify-content-center my-2">
                    <Button onClick={handleLoadMore} disabled={loadingMore} className="btnBlue" style={{ margin: "auto", width: "auto" }}>
                      {loadingMore ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{" "}
                        </>
                      ) : (
                        t("homeScreen.loadMore")
                      )}
                    </Button>
                  </Row>
                )}
              </>
            )}
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default SubcategoryWiseProduct;